import { role } from "src/pods/realtime/util/role";
import { logEvent as execLogEventCommand } from "src/pods/webviewInit";
import { sendLogEvent } from "@web-monorepo/utilities";

type Event = {
  eventName: string;
  eventValue?: string;
  metadata?: Record<string, unknown>;
};

// Wraps sendLogEvent to add the role to the event name
export default function logEvent(event: Event) {
  return sendLogEvent({ ...event, eventName: `toolkit.${role}.${event.eventName}` });
}

export function logParentToolkitEvent(event: Event) {
  event.eventName = `paid_product.toolkit.${event.eventName}`;
  execLogEventCommand(event, "parent");
}
